import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { AccessoriesOrder } from "../type";
import {
	GetAccessoriesOrderPayload,
	GetAccessoriesOrdersPayload,
	getAccessoriesOrderAsync,
	getAccessoriesOrdersAsync,
	setAccessoriesOrderDetail,
	setAccessoriesOrders,
} from "./accessories-order.slice";

function* getAccessoriesOrdersSaga(
	action: PayloadAction<GetAccessoriesOrdersPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<AccessoriesOrder>>(
				`/dashboard/purchase-orders`,
				{ ...query, type: "sale_car_part" },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setAccessoriesOrders.type, payload: response });
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* getAccessoriesOrderSaga(
	action: PayloadAction<GetAccessoriesOrderPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<AccessoriesOrder>>(
				`/dashboard/purchase-orders/car-parts/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setAccessoriesOrderDetail.type, payload: response });
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetAccessoriesOrders() {
	yield takeLatest(getAccessoriesOrdersAsync, getAccessoriesOrdersSaga);
}

function* watchGetAccessoriesOrder() {
	yield takeLatest(getAccessoriesOrderAsync, getAccessoriesOrderSaga);
}

const accessoriesOrderSaga = [
	watchGetAccessoriesOrders(),
	watchGetAccessoriesOrder(),
];
export default accessoriesOrderSaga;
